export const fandomCmpReady = () => window.fandomCmp && window.fandomCmp.ready;

export const consentGranted = (requiredCategory?: keyof Categories) =>
  requiredCategory === undefined ||
  window.fandomCmp.consents?.[requiredCategory] === true;
